import { CircularProgress, Icon, MenuItem, TextField } from "@mui/material";
import MDAlert from "components/MDAlert";
import MDBox from "components/MDBox";
import TableFilter from "components/TableFilter/TableFilter";
import parseGraphQLError from "utils/graphQL/parseGraphQLError";

export default function SingleChoiceFilter({
  id,
  value,
  loading,
  options,
  error,
  onChange,
  search,
  onOpen,
  onClose,
  onEndReached,
  hasMorePages = false,
}: {
  id: string;
  value: any;
  loading: boolean;
  options: { label: string; value: string }[];
  error: any;
  onChange: (value: any) => void;
  search?: (value: string) => void;
  onOpen?: () => void;
  onClose?: () => void;
  onEndReached?: () => void;
  hasMorePages?: boolean;
}) {
  return (
    <TableFilter value={value} id={id} onOpen={onOpen} onClose={onClose}>
      {error && (
        <MDBox sx={{ maxWidth: "250px" }}>
          <MDAlert color="error">{parseGraphQLError(error)}</MDAlert>
        </MDBox>
      )}
      {!error && (
        <>
          {search && (
            <TextField
              fullWidth
              size="small"
              placeholder="Search companies"
              onChange={(event) => search(event.target.value)}
              sx={{ mb: 1 }}
            />
          )}
          {loading && options.length === 0 ? (
            <MDBox display="flex" justifyContent="center" py={2}>
              <CircularProgress color="inherit" size="18px" />
            </MDBox>
          ) : (
            <MDBox
              sx={{ maxHeight: "250px", overflowY: "auto" }}
              onScroll={(event) => {
                const list = event.currentTarget;
                if (hasMorePages && list.scrollTop + list.clientHeight >= list.scrollHeight - 32) {
                  onEndReached?.();
                }
              }}
            >
              <MenuItem
                selected={value === null}
                value={null}
                onClick={() => onChange(null)}
                sx={{ pl: "20px" }}
              >
                {value === null ? (
                  <Icon sx={{ position: "absolute", left: "4px" }}>checked</Icon>
                ) : (
                  ""
                )}
                ALL
              </MenuItem>
              {options.map((company) => {
                const selected = value === company.value;

                return (
                  <MenuItem
                    selected={selected}
                    key={company.value}
                    value={company.value}
                    onClick={() => onChange(company.value)}
                    sx={{ pl: "20px" }}
                  >
                    {selected ? (
                      <Icon sx={{ position: "absolute", left: "4px" }}>checked</Icon>
                    ) : (
                      ""
                    )}

                    {company.label}
                  </MenuItem>
                );
              })}
            </MDBox>
          )}
          {loading && options.length > 0 && (
            <MDBox display="flex" justifyContent="center" py={1}>
              <CircularProgress color="inherit" size="14px" />
            </MDBox>
          )}
        </>
      )}
    </TableFilter>
  );
}
